// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"_-ui-admin-lib-CardContent-index-module__cardContent--3EqDx"};